import { Evaluation } from '../../Components/Evaluation360/Evaluation'

export function EvaluationEmployee() {
	return <Evaluation />
}
